import { createSlice } from "@reduxjs/toolkit";
import { ErrorType, RootState } from "../../../app/store";
import { PmDisbursementDetail, PmDisbursementsDTO, PmDisburseThresholdDetail } from "@inosio/payments-sdk";

interface ITransDataPage {
  Rows: Array<PmDisbursementDetail>;
}

type PMState = {
  DisbursementHistory: PmDisbursementsDTO;
  TransDataPages: Array<ITransDataPage>;
  Thresholds: PmDisburseThresholdDetail;
  isSuccess: Boolean;
  isFetchingDisbursement: Boolean;
  errorMessage: ErrorType;
};

const getInitialState = () => {
  return {
    DisbursementHistory: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
    TransDataPages: [],
    Thresholds: { Enabled: false, PerPayment: { Max: 0 }, ThreeDay: { Max: 0, Processed: 0 }, Monthly: { Max: 0, Processed: 0 } },
    isSuccess: false,
    isFetchingDisbursement: false,
    errorMessage: {} as ErrorType,
  } as PMState;
};

const pmDisbursementsSlice = createSlice({
  name: "pmDisbursements",
  initialState: getInitialState(),
  reducers: {
    getDisbursementHistoryDetails(state, action) {
      state.errorMessage = {} as ErrorType;
      state.isFetchingDisbursement = true;
      state.isSuccess = true;
    },
    setDisbursementHistoryDetails(state, action) {
      /*
      this function has one responsiblity: receive updates from API
      and put the results in state.
      */
      let _payload = action.payload as PmDisbursementsDTO;

      //get a copy of the current book
      let currentTransPages = [...state.TransDataPages];

      //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
      if (_payload.RecordStart === 0) currentTransPages = [];

      //find out what page we are on
      let whatPageResultsIsThis = Math.ceil((_payload.RecordStart || 0) / (_payload.RangeSize || 1));

      //now, add this new data page to our book
      currentTransPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows ?? [],
      };

      //return the full
      let disbursementsHistoryDetailsData = {
        DisbursementHistory: action.payload,
        TransDataPages: currentTransPages,
        isFetchingDisbursement: false,
        Thresholds: _payload.Thresholds ?? state.Thresholds,
      };

      return { ...state, ...disbursementsHistoryDetailsData };
    },
    setDisbursementHistoryDetailsExport(state){
      state.isFetchingDisbursement=false;
  },
    setDisbursementHistoryDetailError(state, action){
      state.isFetchingDisbursement = false;
      state.errorMessage = action.payload
    },
  },
});

export const {
  getDisbursementHistoryDetails,
  setDisbursementHistoryDetails,
  setDisbursementHistoryDetailError,
  setDisbursementHistoryDetailsExport
} = pmDisbursementsSlice.actions;

export default pmDisbursementsSlice.reducer;

export const selectDisbursementHistoryDetails = (state: RootState) => state.pmDisbursementsState.DisbursementHistory;
export const selectDisburseHistoryDetailsCurrentPage = (state: RootState) => state.pmDisbursementsState.TransDataPages;
export const selectPmDisbursementsState = (state: RootState) => state.pmDisbursementsState;
